<template>
  <div class="app">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <Loader />
    </div>
    <div class="datepickerwrap">
      <div class="card">
        <div class="profile-cover-bg w-full">
          <div class="avatar-container">
            <img v-if="personalInfo.profile_image" class="user-avatar" :src="personalInfo.profile_image"
              alt="user-avatar">
            <img v-else class="user-avatar" src="../../../public/Icons_SVG/User.svg" alt="user-avatar-logo"
              style="border:1px solid #000;">
            <!-- Profile image upload Pop-up Model -->
            <b-button v-b-modal.modal-center class="edit-icon">
              <img src="../../../public/img/edit-avatar-icon.svg">
            </b-button>
            <div class="upload-img-model">
              <div>
                <b-modal ref="upload-img-modal" id="modal-center" centered title="Update Profile Image">
                  <div class="upload-img-section">
                    <div class="img-preview">
                      <img v-if="preview" :src="preview" alt="">
                      <img v-else src="../../../public/Icons_SVG/User.svg" alt="">
                    </div>
                    <label for="upload-photo">
                      <svg xmlns="http://www.w3.org/2000/svg" height="1.2rem" viewBox="0 0 640 512">
                        <path fill="#ffffff"
                          d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z" />
                      </svg><span>Choose Image</span>
                    </label>
                  </div>
                  <div class="upload-btn">
                    <b-button v-on:click="uploadImage" v-if="this.imgFile" variant="success" class="upload-btn">
                      <b-spinner small v-if="isUploadingLoader" style="margin-right:0.5rem;"></b-spinner>{{ btnStatus
                      }}
                    </b-button>
                    <b-button v-on:click="uploadImage" v-else variant="danger" disabled
                      class="upload-btn">Upload</b-button>
                  </div>

                  <input type="file" accept="image/*" id="upload-photo" style="display: none;"
                    v-on:change="updateProfileImg" />

                </b-modal>
              </div>
            </div>
            <!-- ! Profile image upload Pop-up Model -->
          </div>
        </div>
        <div class="user-details">
          <div class="user-info">
            <h4 class="user-name">{{ personalInfo.first_name + " " + personalInfo.last_name }}</h4>
            <p class="user-title">{{ personalInfo.brand_name }}</p>
          </div>
          <div class="edit-btn" v-on:click="editProfileBtn()">
            <div v-if="toggleProfileInfo">
              <img src="../../../public/img/edit-avatar-icon.svg"> <span>Edit
                Profile</span>
            </div>
            <span v-else>Cancel</span>
          </div>
        </div>
        <!-- -------------------Personal Info------------ -->
        <div v-if="toggleProfileInfo" class="UpToDateInfo container">
          <div class="info-table">
            <h4>Personal Information</h4>
            <table>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
              </tr>
              <tr>
                <td>{{ personalInfo.first_name }}</td>
                <td>{{ personalInfo.last_name }}</td>
              </tr>
              <tr>
                <th>Email ID</th>
                <th>Phone Number</th>
              </tr>
              <tr>
                <td>{{ personalInfo.email }}</td>
                <td>{{ personalInfo.phone_number }}</td>
              </tr>
            </table>
          </div>
          <div class="bill-table">
            <h4>Billing Details</h4>
            <table>
              <tr>
                <th>Plan Name</th>
                <th>Billing Cycle </th>
                <th>Status </th>
              </tr>
              <tr>
                <td>{{ this.bellingDetails["Plan Name"] }}</td>
                <td>{{ this.bellingDetails["Billing Cycle"] }}</td>
                <td v-if="this.bellingDetails['Status'] === 'Active'" class="active">{{ this.bellingDetails["Status"] }}
                </td>
                <td v-else class="inactive">{{ this.bellingDetails["Status"] }}
                </td>
              </tr>

            </table>
          </div>
        </div>
        <!-- -------------------! Personal Info------------ -->

        <!-- -------------------Profile Edit Form------------ -->
        <div v-if="toggleEditProfileInfo" class="editInfo container">
          <h4 class="mt-4 fw-bold">Personal Information</h4>
          <p class="mb-4">Manage your details, click to edit your information.</p>

          <b-row class="mb-4">
            <b-col class="col-4">
              <label for="first_name">First Name</label>
              <b-form-input id="first_name" v-model="editedPersonalInfo.first_name"
                placeholder="First name"></b-form-input>
            </b-col>
            <b-col class="col-4">
              <label for="last_name">Last Name</label>
              <b-form-input id="last_name" v-model="editedPersonalInfo.last_name"
                placeholder="Last name"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col class="col-4">
              <label for="email">Email ID</label>
              <b-form-input type="email" id="email" v-model="editedPersonalInfo.email" :class="{ validateError: false }"
                placeholder="abc@example.com"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4 d-flex align-items-center">
            <b-col class="col-4">
              <label for="password">Current Password</label>
              <b-form-input disabled id="password" v-model="editedPersonalInfo.existing_password"
                placeholder="***********"></b-form-input>
            </b-col>
            <b-col class="col-4 mt-4">
              <span class="changePassword" v-on:click="openPasswordChange()">Change Password?</span>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col class="col-4">
              <label for="phone_number">Phone Number</label>
              <b-form-input id="phone_number" v-model="editedPersonalInfo.phone_number" placeholder="+91 1234567890"
                maxlength="10" :class="{ validateError: false }"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col class="col-4">
              <button type="button" class="btn btn-outline-danger mr-4" v-on:click="discardEditProfile()">Discard
                Changes</button>
              <button type="button" class="btn btn-success" style="background-color: #008075;"
                v-on:click="saveEditProfileInfo()">
                <b-spinner small v-if="isUploadingLoader" style="margin-right:0.5rem;"></b-spinner>Save Changes
              </button>
            </b-col>
          </b-row>
        </div>
        <!-- -------------------! Profile Edit Form------------ -->

        <!-- -------------------Password change Form------------ -->
        <div v-if="togglePasswordChange" style="margin-top: 2.5rem;" class="passwordChange container">
          <h4 class="mt-4 fw-bold">Change Password</h4>
          <p class="mb-4">Change your existing password</p>
          <b-row class="flex justify-content-between align-items-center">
            <b-col class="col-4">
              <b-row class="mb-4">
                <b-col>
                  <label for="existing_password">Current Password</label>
                  <b-input-group :class="{ 'validateError': errorChangePassword.isCurrentPasswordValidate }"
                    class="passwordInput">
                    <b-form-input v-if="toggleCurrentPassword" type="password" class="passwordField"
                      id="existing_password" placeholder="***********" v-model="existing_password"></b-form-input>
                    <b-form-input v-else class="passwordField" type="text" id="existing_password"
                      placeholder="***********" v-model="existing_password"></b-form-input>
                    <b-input-group-append>
                      <b-button v-on:click="toggleCurrentPassword = !toggleCurrentPassword" class="eyeBtn">
                        <svg v-if="toggleCurrentPassword" xmlns="http://www.w3.org/2000/svg" height="20" width="22.5"
                          viewBox="0 0 576 512">
                          <path fill="#ababab"
                            d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" height="20" width="22.5">
                          <path fill="#ababab"
                            d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z" />
                        </svg>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <span v-if="errorChangePassword.existing_password" style="color: red;">{{
                    errorChangePassword.existing_password }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col>
                  <label for="new_password">Enter New Password</label>
                  <b-input-group :class="{ 'validateError': errorChangePassword.isNewPasswordValidate }"
                    class="passwordInput">
                    <b-form-input v-if="toggleNewPassword" v-on:input="computedValue()" class="passwordField"
                      type="password" id="new_password" v-model="new_password" :state="new_password"
                      placeholder="Enter New Password"></b-form-input>
                    <b-form-input v-else v-on:input="computedValue()" class="passwordField" type="text"
                      id="new_password" v-model="new_password" :state="new_password"
                      placeholder="Enter New Password"></b-form-input>
                    <b-input-group-append>
                      <b-button v-on:click="toggleNewPassword = !toggleNewPassword" class="eyeBtn">
                        <svg v-if="toggleNewPassword" xmlns="http://www.w3.org/2000/svg" height="20" width="22.5"
                          viewBox="0 0 576 512">
                          <path fill="#ababab"
                            d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" height="20" width="22.5">
                          <path fill="#ababab"
                            d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z" />
                        </svg>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <span v-if="errorChangePassword.new_password" style="color: red;">{{ errorChangePassword.new_password
                    }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col>
                  <label for="re_new_password">Re-enter New Password</label>
                  <b-input-group :class="{ 'validateError': errorChangePassword.isNewPasswordValidate }"
                    class="passwordInput">
                    <b-form-input v-if="toggleReNewPassword" v-on:input="computedValue()" class="passwordField"
                      type="password" id="re_new_password" v-model="re_new_password" :state="re_new_password"
                      placeholder="Re-enter New Password"></b-form-input>
                    <b-form-input v-else v-on:input="computedValue()" class="passwordField" type="text"
                      id="re_new_password" v-model="re_new_password" :state="re_new_password"
                      placeholder="Re-enter New Password"></b-form-input>
                    <b-input-group-append>
                      <b-button v-on:click="toggleReNewPassword = !toggleReNewPassword" class="eyeBtn">
                        <svg v-if="toggleReNewPassword" xmlns="http://www.w3.org/2000/svg" height="20" width="22.5"
                          viewBox="0 0 576 512">
                          <path fill="#ababab"
                            d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" height="20" width="22.5">
                          <path fill="#ababab"
                            d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z" />
                        </svg>

                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <span v-if="errorChangePassword.re_new_password" style="color: red;">{{
                    errorChangePassword.re_new_password }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col>
                  <button type="button" v-on:click="discardPasswordChange()" class="btn btn-outline-danger mr-4">Discard
                    Changes</button>
                  <button type="button" v-on:click="changePassword()" class="btn btn-success"
                    style="background-color: #008075;">
                    <b-spinner small v-if="isUploadingLoader" style="margin-right:0.5rem;"></b-spinner>Save
                    Changes
                  </button>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="col-4">
              <ul class="border p-4 passwordRule">
                <li v-if="this.passwordValidationMessage" style="color: red;">{{ passwordValidationMessage }}</li>
                <li>Have one number </li>
                <li>Have at least one uppercase</li>
                <li>Have at least one lowercase</li>
                <li>Have at least one special character</li>
                <li>Have minimum 8 characters</li>
              </ul>
            </b-col>

          </b-row>
        </div>
        <!-- ------------------- ! Password change Form------------ -->

      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../Components/Loader.vue';
export default {
  name: "profileDetail",
  components: {
    Loader
  },
  data: function () {
    return {
      personalInfo: {},
      bellingDetails: {},
      editedPersonalInfo: {},
      preview: null,
      imgFile: null,
      btnStatus: "Upload",
      isUploadingLoader: false,
      existing_password: "",
      new_password: "",
      re_new_password: "",
      errorChangePassword: {
        existing_password: "",
        new_password: "",
        re_new_password: "",
        isCurrentPasswordValidate: false,
        isNewPasswordValidate: false,
      },
      toggleProfileInfo: true,
      toggleEditProfileInfo: false,
      togglePasswordChange: false,
      toggleCurrentPassword: true,
      toggleNewPassword: true,
      toggleReNewPassword: true,
      passwordValidate: true,
      passwordValidationMessage: "",
      loader: false,
      emailValidate: false,
      phoneNumberValidate: false,
    };
  },
  computed: {
    isPasswordValid() {
      // Regular expressions for each condition
      const hasNumber = /\d/.test(this.new_password);
      const hasUpperCase = /[A-Z]/.test(this.new_password);
      const hasLowerCase = /[a-z]/.test(this.new_password);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(this.new_password);
      const isMinimumLength = this.new_password.length >= 8;

      // Check all conditions
      if (!hasNumber) {
        this.passwordValidationMessage = 'Password must contain at least one number';
        return false;
      }
      if (!hasUpperCase) {
        this.passwordValidationMessage = 'Password must contain at least one uppercase letter';
        return false;
      }
      if (!hasLowerCase) {
        this.passwordValidationMessage = 'Password must contain at least one lowercase letter';
        return false;
      }
      if (!hasSpecialChar) {
        this.passwordValidationMessage = 'Password must contain at least one special character';
        return false;
      }
      if (!isMinimumLength) {
        this.passwordValidationMessage = 'Password must be at least 8 characters long';
        return false;
      }

      // If all conditions are met, password is valid
      this.passwordValidationMessage = '';
      return true;
    }
  },
  mounted() {
    this.loader = true;
    this.fetchProfileInfo();
    this.fetchBillingDetails();
  },
  methods: {
    discardEditProfile() {
      // this.toggleProfileInfo = !this.toggleProfileInfo;
      // this.toggleEditProfileInfo = !this.toggleEditProfileInfo;
      this.fetchProfileInfo();
    },
    fetchBillingDetails() {
      let url = "/api/v2/reviews/billing";
      // const myToken = JSON.parse(localStorage.getItem("reviewUserData"));
      // this.$http.get(url, {
      //   headers: {
      //     'Authorization': `Bearer ${myToken.data.toke}`
      //   }
      // })
      this.$http.get(url)
        .then((response) => {
          return response.json();
        })
        .then((jsonData) => {
          this.bellingDetails = jsonData.data;
          // Billing Cycle: "N/A",
          // Plan Name: "N/A",
          // Status: "Inactive",
          this.loader = false;
        })
        .catch((err) => {
          console.error("Could not fetch data", err);
        });
    },
    fetchProfileInfo() {
      let url = "/api/v2/reviews/profile";
      this.$http.get(url)
        .then((response) => {
          return response.json();
        })
        .then((jsonData) => {
          this.personalInfo = jsonData.data;
          this.editedPersonalInfo = {
            ...this.personalInfo
          };
          this.loader = false;
        })
        .catch((err) => {
          console.error("Could not fetch data", err);
        });
    },
    updateProfileImg(event) {
      const file = event.target.files[0];
      this.imgFile = file;
      if (file) {
        this.preview = URL.createObjectURL(file)
      } else {
        this.preview = null;
      }
    },
    editProfileBtn() {
      this.toggleProfileInfo = !this.toggleProfileInfo;
      this.toggleEditProfileInfo = !this.toggleEditProfileInfo;
      if (this.togglePasswordChange) {
        this.togglePasswordChange = !this.togglePasswordChange;
        this.toggleEditProfileInfo = !this.toggleEditProfileInfo;
      }
    },
    openPasswordChange() {
      this.togglePasswordChange = !this.togglePasswordChange;
      if (this.togglePasswordChange) {
        this.toggleProfileInfo = false;
        this.toggleEditProfileInfo = false;
      }
    },
    compareObjects(obj1, obj2) {
      if (!obj1 || !obj2) {
        return false;
      }
      let keys = Object.keys(obj1);
      let isSameValue = [];
      for (let key of keys) {
        if (obj1[key] === obj2[key]) {
          isSameValue.push(true);
        } else {
          isSameValue.push(false);
        }
      }
      if (isSameValue.every((value) => value === true)) {
        return false;
      } else {
        return true;
      }

    },
    saveEditProfileInfo() {
      const phoneNumberPattern = /^\d{10}$/;
      const emailRegex = /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;
      this.phoneNumberValidate = phoneNumberPattern.test(this.editedPersonalInfo.phone_number);
      this.emailValidate = emailRegex.test(this.editedPersonalInfo.email);

      if (this.compareObjects(this.personalInfo, this.editedPersonalInfo)) {
        if (!this.emailValidate) {
          this.$bvToast.toast(`Email is not valid! ❌`, {
            title: "Weavr Sense - Edit Profile",
            variant: "danger",
            toaster: "b-toaster-top-right",
            autoHideDelay: 3000,
          });
          return "Email is not valid!"
        }
        if (!this.phoneNumberValidate) {
          this.$bvToast.toast(`Phone Number is not valid! ❌`, {
            title: "Weavr Sense - Edit Profile",
            variant: "danger",
            toaster: "b-toaster-top-right",
            autoHideDelay: 3000,
          });
          return "Phone Number is not valid!"
        }
        this.isUploadingLoader = true;
        let url = "/api/v2/reviews/profile";
        let data = {
          first_name: this.editedPersonalInfo.first_name,
          last_name: this.editedPersonalInfo.last_name,
          phone_number: this.editedPersonalInfo.phone_number,
          email: this.editedPersonalInfo.email,
        };
        this.$http.post(url, data)
          .then((response) => {
            this.fetchProfileInfo()
            this.isUploadingLoader = false;
            this.discardEditProfile();
            this.$bvToast.toast(`Data Updated Successfully! ✅`, {
              title: "Weavr Sense - Personal Details",
              variant: "success",
              toaster: "b-toaster-top-center",
              autoHideDelay: 3000,
            });
          })
          .catch((error) => {
            console.error('Error Updating personal Information:', error);
          });
      } else {
        this.$bvToast.toast(`Already up to date!`, {
          title: "Weavr Sense - Personal Details",
          variant: "warning",
          toaster: "b-toaster-top-right",
          autoHideDelay: 3000,
        });
      }

    },
    uploadImage() {
      if (this.imgFile) {
        this.btnStatus = "Uploading...";
        this.isUploadingLoader = true;
        let formData = new FormData();
        formData.append('profile_image', this.imgFile);
        let url = "/api/v2/reviews/profile_image";
        this.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((response) => {
            this.fetchProfileInfo()
            this.preview = null;
            this.imgFile = null;
            this.isUploadingLoader = false;
            this.btnStatus = "Upload";
            this.$refs['upload-img-modal'].hide()
            this.$bvToast.toast(`Uploaded Successfully ✅`, {
              title: "Weavr Sense - Profile Image",
              variant: "success",
              toaster: "b-toaster-top-center",
              autoHideDelay: 3000,
            });
          })
          .catch((error) => {
            console.error('Error uploading profile image:', error);
          });
      }

    },
    discardPasswordChange() {
      this.existing_password = "";
      this.new_password = "";
      this.re_new_password = "";
      this.errorChangePassword = {
        existing_password: "",
        new_password: "",
        re_new_password: "",
        isCurrentPasswordValidate: false,
        isNewPasswordValidate: false,
      };
      this.isUploadingLoader = false;
      // this.toggleProfileInfo = false;
      // this.toggleEditProfileInfo = true;
      // this.togglePasswordChange = false;
      this.passwordValidationMessage = ""
      this.toggleCurrentPassword = true;
      this.toggleNewPassword = true;
      this.toggleReNewPassword = true;
    },
    validateChangePassword() {
      this.errorChangePassword = {
        existing_password: this.existing_password ? '' : 'Current password is required.',
        new_password: this.new_password ? '' : 'New password is required.',
        re_new_password: this.re_new_password ? '' : 'Please re-enter the new password.',
        isCurrentPasswordValidate: this.existing_password ? '' : true,
        isNewPasswordValidate: this.new_password ? '' : true,
      };
      if (this.new_password !== this.re_new_password) {
        this.$bvToast.toast(`New Password & Re-New Password should be same!`, {
          title: "Weavr Sense - Change Password",
          variant: "danger",
          toaster: "b-toaster-top-right",
          autoHideDelay: 3000,
        });
        this.errorChangePassword.isNewPasswordValidate = true;
        return false;
      }
      return this.errorChangePassword.existing_password === '' && this.errorChangePassword.new_password === '' && this.errorChangePassword.re_new_password === '';
    },
    changePassword() {
      if (this.validateChangePassword()) {
        let url = "/api/v2/reviews/password";
        this.isUploadingLoader = true;
        let data = {
          existing_password: this.existing_password,
          new_password: this.new_password,
        };
        this.$http.post(url, data)
          .then((response) => {
            this.isUploadingLoader = false;
            this.$bvToast.toast(`Password Changed Successfully! ✅`, {
              title: "Weavr Sense - Profile Password",
              variant: "success",
              toaster: "b-toaster-top-center",
              autoHideDelay: 3000,
            });
          })
          .catch((error) => {
            this.discardPasswordChange();
            console.error('Error Changing Password:', error);
            this.$bvToast.toast(`Enter Valid Current Password`, {
              title: "Weavr Sense - Change Password",
              variant: "danger",
              toaster: "b-toaster-top-right",
              autoHideDelay: 3000,
            });
          });

      }
    },
    computedValue() {
      this.isValidate = false;
      if (this.new_password === "") {
        this.passwordValidationMessage = "";
      } else {
        this.isPasswordValid();
      }
    },
  },
};
</script>

<style scoped>
img {
  width: 100%;
}

.card {
  border: none !important;
}

.profile-cover-bg {
  background: rgb(0, 146, 133);
  background: linear-gradient(273deg, rgba(0, 146, 133, 1) 0%, rgba(0, 90, 93, 1) 51%);
  height: 200px;
  width: 100%;
  border-radius: 1.2rem;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
}

.profile-cover-bg .avatar-container {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 4px solid #fff;
  position: absolute;
  top: 50%;
  transform: translateY(20%);
  left: 7%;
  z-index: 899;
  background-color: #f9f9f9;
}

.profile-cover-bg .avatar-container>img {
  border-radius: 50%;
  width: 100%;
  height: 100%;
}

.profile-cover-bg .avatar-container .edit-icon {
  width: 25%;
  height: 25%;
  border: 2px solid #f9f9f9;
  background-color: #008075;
  padding: 5%;
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: pointer;
  transition: box-shadow 0.1s ease-out;
}

.upload-img-section {
  height: 25vh;
  width: 100%;
  background-color: #f9f9f9;
  border: 2px dashed #008075;
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.upload-img-section .img-preview {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
}

.upload-img-section .img-preview img {
  width: 100%;
  height: 100%;
}

.upload-img-section label {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-align: center;
  background-color: #008075;
  padding: 0.5rem 0.7rem;
  margin-top: 1rem;
  color: #fff;
  gap: 0.5rem;
  border-radius: 0.5rem;
  border: 2px dashed transparent;
  transition: all 0.1s ease-in-out;
  opacity: 0.8;
}

.upload-img-section label:hover {
  border: 2px dashed #fff;
  opacity: 0.9;
}

.upload-btn {
  margin-top: 0.5rem;
  display: flex;
  justify-content: center;
}

.user-details {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.user-details .user-info {
  position: relative;
  left: 270px;
  left: calc(15% + 100px);
}

.user-details .user-info .user-title {
  color: #887979;
}

.edit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.6rem;
  background-color: #008075;
  cursor: pointer;
  border-radius: 7px;
  color: #fff;
  margin-top: 10px;
}

.edit-btn div {
  display: flex;
  justify-content: space-between;
  gap: 5px;
  align-items: center;
}

.edit-btn img {
  width: 1.2em;
}

table {
  width: 98%;
  margin: 0 auto;
  border-spacing: 0.5em;
}

table th {
  color: #5e5e53;
  font-weight: 100;
}

.info-table h4,
.bill-table h4 {
  border-left: 2px solid #008075;
  padding-left: 0.5rem;
  margin-bottom: 1rem;

}

.info-table th,
.bill-table th {
  color: #008075;
}

table .active {
  color: #008075;
}

table .inactive {
  color: #a4a4a4;
}

.info-table,
.bill-table {
  margin-top: 3rem;
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 10px;
}

/*---------edit Profile form style----------*/
.editInfo {
  margin-top: 3rem !important;
}

.editInfo .changePassword {
  color: #008075;
  border-bottom: 2px solid #008075;
  padding-bottom: 2px;
  cursor: pointer;
  opacity: 0.8;
  transition: all 0.1s ease-out;
}

.editInfo .changePassword:hover {
  opacity: 1;
}

.passwordRule {
  color: #606060;
  border-radius: 0.5rem;
}

.passwordRule li {
  margin-left: 1rem;
}

.passwordRule li::marker {
  color: #e8e8e8;
  font-size: 1rem;
}

.passwordInput {
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.passwordInput:focus-within {
  box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
  border-color: #66afe9 !important;
}

.passwordInput .passwordField {
  border: none;
}

.passwordInput .passwordField:focus {
  border: none;
  box-shadow: none;
}

.passwordInput .eyeBtn {
  border: none;
  background-color: transparent !important;
}

.passwordInput .eyeBtn:hover {
  background-color: #f5f5f5 !important;
}

.validateError {
  box-shadow: 0 0 0 0.2rem rgba(216, 32, 32, 0.25) !important;
  border-color: #e96666 !important;
}

.passwordInput .eyeBtn:focus {
  box-shadow: none !important;
}

.editInfo,
.UpToDateInfo {
  max-width: 95% !important;
}
</style>
